<template>
  <div class="d-flex flex-column" style="height: 100%">
    <v-row class="flex-shrink-1">
      <v-col>
        <v-alert class="mb-0" type="info">업무일 기준 1-2일 내로 답변 드리겠습니다.</v-alert>
      </v-col>
    </v-row>

    <v-container fluid class="scroll flex-grow-1" ref="wrapper">
      <v-row>
        <v-col class="flex-grow-0 flex-shrink-1 d-flex align-end" order="last">
          <v-avatar color="primary" style="position: sticky; bottom: 4px">
            <span class="white--text">A</span>
          </v-avatar>
        </v-col>
        <v-col class="pa-0 d-flex flex-column align-end">
          <v-card v-bind="messageBox">
            <v-card-text>{{ lorem }}</v-card-text>
          </v-card>
          <v-card v-bind="messageBox">
            <v-card-text>message</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="flex-grow-0 flex-shrink-1 d-flex align-end" order="last">
          <v-avatar color="primary" style="position: sticky; bottom: 4px">
            <span class="white--text">A</span>
          </v-avatar>
        </v-col>
        <v-col class="pa-0 d-flex flex-column align-end">
          <v-card v-bind="messageBox">
            <v-card-text>{{ lorem }}</v-card-text>
          </v-card>
          <v-card v-bind="messageBox">
            <v-card-text>message</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="flex-grow-0 flex-shrink-1 d-flex align-end" order="last">
          <v-avatar color="primary" style="position: sticky; bottom: 4px">
            <span class="white--text">A</span>
          </v-avatar>
        </v-col>
        <v-col class="pa-0 d-flex flex-column align-end">
          <v-card v-bind="messageBox">
            <v-card-text>{{ lorem }}</v-card-text>
          </v-card>
          <v-card v-bind="messageBox">
            <v-card-text>message</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="flex-grow-0 flex-shrink-1 d-flex align-end">
          <v-avatar color="primary" style="position: sticky; bottom: 4px">
            <span class="white--text">A</span>
          </v-avatar>
        </v-col>
        <v-col class="pa-0 d-flex flex-column align-start">
          <v-card v-bind="messageBox">
            <v-card-text>{{ lorem }}</v-card-text>
          </v-card>
          <v-card v-bind="messageBox" color="primary">
            <v-card-text>message</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="flex-grow-0 flex-shrink-1 d-flex align-end" order="last">
          <v-avatar color="primary" style="position: sticky; bottom: 4px">
            <span class="white--text">A</span>
          </v-avatar>
        </v-col>
        <v-col class="pa-0 d-flex flex-column align-end">
          <v-card v-bind="messageBox">
            <v-card-text>{{ lorem }}</v-card-text>
          </v-card>
          <v-card v-bind="messageBox">
            <v-card-text>message</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="flex-grow-0 flex-shrink-1 d-flex align-end" order="last">
          <v-avatar color="primary" style="position: sticky; bottom: 4px">
            <span class="white--text">A</span>
          </v-avatar>
        </v-col>
        <v-col class="pa-0 d-flex flex-column align-end">
          <v-card v-bind="messageBox">
            <v-card-text>{{ lorem }}</v-card-text>
          </v-card>
          <v-card v-bind="messageBox">
            <v-card-text>message</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="flex-grow-0 flex-shrink-1 d-flex align-end" order="last">
          <v-avatar color="primary" style="position: sticky; bottom: 4px">
            <span class="white--text">A</span>
          </v-avatar>
        </v-col>
        <v-col class="pa-0 d-flex flex-column align-end">
          <v-card v-bind="messageBox">
            <v-card-text>{{ lorem }}</v-card-text>
          </v-card>
          <v-card v-bind="messageBox">
            <v-card-text>message</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="flex-grow-0 flex-shrink-1 d-flex align-end" order="last">
          <v-avatar color="primary" style="position: sticky; bottom: 4px">
            <span class="white--text">A</span>
          </v-avatar>
        </v-col>
        <v-col class="pa-0 d-flex flex-column align-end">
          <v-card v-bind="messageBox">
            <v-card-text>{{ lorem }}</v-card-text>
          </v-card>
          <v-card v-bind="messageBox">
            <v-card-text>message</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-row class="flex-shrink-1">
      <v-col>
        <v-form @submit.prevent="submit">
          <v-text-field
            label="메시지"
            single-line
            outlined
            hide-details
            append-icon="mdi-send"
            @click:append="submit"
          >
          </v-text-field>
          <v-btn icon type="submit" v-show="false">
            <v-icon>mdi-send</v-icon>
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      messages: [],
      lorem: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur aliquam odio pulvinar imperdiet ornare. Mauris ultrices placerat lacus, ac consequat justo pellentesque vel. Suspendisse ac consectetur nisi. Pellentesque posuere aliquet arcu ut aliquet. Nam lacinia, nisi quis molestie dictum, ex erat lobortis ex, at pretium risus libero ut felis. Pellentesque tellus neque, dapibus et rutrum ut, gravida at odio. Etiam feugiat lacinia orci, vel scelerisque odio pulvinar fermentum. Praesent pretium at orci sit amet finibus. Suspendisse sit amet malesuada nunc. Sed et tellus a risus rhoncus malesuada vel in lectus. Fusce auctor volutpat risus vitae malesuada. Nam ut metus at lorem placerat interdum nec eget eros. Vivamus nec nulla tincidunt, suscipit lacus eu, sodales ipsum. Suspendisse elit lorem, sagittis vel eleifend eget, ullamcorper ac turpis. Nam pulvinar placerat orci. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.'
    }
  },
  mounted () {
    const wrapper = this.$refs.wrapper
    const lastMessage = this.$el.querySelector('#message')

    wrapper.scrollTop = lastMessage ? lastMessage.offsetTop - wrapper.offsetTop : wrapper.scrollHeight
  },
  computed: {
    messageBox () {
      return {
        class: 'ma-2',
        style: {
          maxWidth: this.$vuetify.breakpoint.xs ? null : '70%'
        }
      }
    }
  },
  methods: {
    submit () {
      alert('message')
    }
  }
}
</script>

<style scoped>
  .scroll {
    overflow-y: scroll;
    overflow-x: hidden
  }
</style>
